module.exports = __webpack_public_path__ + "static/media/JUNI-BNB.28c2f387.svg";